<!--
 * @Author: yangguodong
 * @Date: 2025-09-22 09:41:55
 * @LastEditors: yangguodong yanggd@geovis.com.cn
 * @LastEditTime: 2025-10-29 16:40:56
 * @FilePath: \ngtc-traceability-admin\src\app\layout\layout-basic\app-frame-layout.component.html
 * @Description: 
 * 
 * Copyright (c) 2025 by ${yangguodong}, All Rights Reserved. 
-->
<nz-layout class="app-layout">
  <nz-sider class="menu-sidebar" nzCollapsible nzWidth="256px" nzBreakpoint="md" [(nzCollapsed)]="isCollapsed"
    [nzTrigger]="null">
    <div class="sidebar-logo">
      <a href="javascript:void(0)">
        <img src="assets/images/logo.png" alt="logo">
        <h1>宝源码溯源管理系统</h1>
      </a>
    </div>
    <div class="menu-bg">
      <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
        <li nz-menu-item nz-tooltip nzTooltipPlacement="right" nzMatchRouter >
          <i nz-icon nzType="pie-chart" nzTheme="outline"></i>
          <span><a (click)="onMenuClick({id:'61cfbb53-7c1c-4ae9-8e88-35513fe4be89'})">驾驶舱统计数据</a></span>
        </li>
        <div class="menu-container">
          <!-- 引入递归菜单组件，传入顶级菜单数据 -->
          <app-menu [menuItems]="menus" (menuItemClick)="onMenuClick($event)"></app-menu>    
        </div>
      </ul>
      <div class="footer-menu-bg">
        <img class="footer-bg" src="/assets/images/footer-bg.png" alt="">
      </div> 
    </div>

  </nz-sider>
  <nz-layout>
    <nz-header>
      <div class="app-header">
        <span class="header-trigger" (click)="isCollapsed = !isCollapsed">
          <i class="trigger" nz-icon [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"></i>
        </span>
      </div>
      <div class="app-right">
        <div nz-dropdown [nzDropdownMenu]="menu" nzPlacement="bottomLeft">
          <nz-avatar  nzIcon="user" [nzSrc]="photoUrl"></nz-avatar>
          <span class="account-label">{{ nickName }}</span>
        </div>
        <nz-dropdown-menu #menu="nzDropdownMenu">
          <ul nz-menu>
            <!-- <li nz-menu-item><a href="javascript:void(0)" routerLink="/personal"><i nz-icon nzType="user" nzTheme="outline"></i>个人信息</a></li> -->
            <li nz-menu-item><a href="javascript:void(0)" (click)="pwdSet()"><i nz-icon nzType="safety-certificate" nzTheme="outline"></i>&nbsp;&nbsp;修改密码</a></li>
            <li nz-menu-item><a href="javascript:void(0)" (click)="logout()"><i nz-icon nzType="logout" nzTheme="outline"></i>&nbsp;&nbsp;登出</a></li>
            <!-- <li nz-menu-item><a href="javascript:void(0)" (click)="ssoLogin()"><i nz-icon nzType="logout" nzTheme="outline"></i>sso登录</a></li> -->
          </ul>
        </nz-dropdown-menu>
      </div>
    </nz-header>
    <nz-content>
      <div class="inner-content">
        <!-- <router-outlet></router-outlet> -->
        <nz-tabset
            [(nzSelectedIndex)]="selectedIndex"
            nzType="editable-card"
            nzHideAdd="true"
            nzClosable="true"
            [nzAnimated]="true"
            (nzClose)="closeTab($event)"
            style="margin:0;"
          >
            <nz-tab *ngFor="let tab of tabs" [nzClosable]="!tab.open" nzCloseIcon="close" [nzForceRender]="true" [nzTitle]="tab.name">
              <div style="width:100%;height: 85vh;padding-bottom: 50px;">
                <iframe style="width:100%;height:100%;overflow-y: auto;border:none;padding:0 20px 20px;" [src]="tab.href"></iframe>
              </div>
            </nz-tab>
          </nz-tabset>
      </div>
    </nz-content>
  </nz-layout>
</nz-layout>
